<template>
  <div class="tab__content">
    <div class="tab__content__item tab__active">
      <div class="row">
        <div class="col-lg-6">
          <ApplicationFile :application="application"/>
          <ApplicationInfo :application="application"/>
          <EconomicIndicators :application="application"/>
        </div>
        <div class="col-lg-6">
          <Users :application="application"/>
        </div>
      </div>
    </div>
    <div class="tabs tabs__line mt-8">
      <ul class="nav">
        <li v-for="tab in tabs" :key="tab.key" class="tab__item">
          <a class="cursor-pointer tab__link"
             :class="{'link__active': activeTab.key === tab.key}"
             @click="activeTab = tab">{{ tab.label }}</a>
        </li>
      </ul>
    </div>
    <div class="tab__content">
      <component :is="activeTab.component" :application="application"/>
    </div>
  </div>
</template>
<script>
import Users from "../../../components/employee/application/Users.vue";
import ApplicationFile from "../../../components/employee/application/ApplicationFile.vue";
import ApplicationInfo from "../../../components/employee/application/ApplicationInfo.vue";
import EconomicIndicators from "../../../components/employee/application/EconomicIndicators.vue";
import Applicants from "../../../components/employee/application/Applicants.vue";
import Customers from "../../../components/employee/application/Customers.vue";
import CertifyingDocuments from "../../../components/employee/application/CertifyingDocuments.vue";
import ProjectDevelopers from "../../../components/employee/application/ProjectDevelopers.vue";

export default {
  props: {
    application: Object
  },
  components: {
    Users,
    ApplicationFile,
    ApplicationInfo,
    EconomicIndicators,
    Applicants,
    Customers,
    CertifyingDocuments,
    ProjectDevelopers,
  },
  data() {
    return {
      activeTab: {
        key: 'applicants',
        label: this.$lang.app.APPLICANT,
        component: 'Applicants'
      },
      tabs: [
        {
          key: 'applicants',
          label: this.$lang.app.APPLICANT,
          component: 'Applicants'
        },
        {
          key: 'customers',
          label: this.$lang.app.CUSTOMER,
          component: 'Customers'
        },
        {
          key: 'documents',
          label: this.$lang.app.DOCUMENTS,
          component: 'CertifyingDocuments'
        },
        {
          key: 'planners',
          label: this.$lang.app.PLANNER,
          component: 'ProjectDevelopers'
        }
      ]
    }
  }
}
</script>